import { SearchBar } from 'components/desktop/organisms';
import { SlotComponentProps } from 'modules/page-builder/types';

export type HeaderSearchProps = SlotComponentProps<{}>;

export const HeaderSearchDesktop: React.FC<HeaderSearchProps> = ({}) => {
  return <SearchBar />;
};
